/* eslint-disable react/no-array-index-key */
import {
  ClickAwayListener,
  TableCell,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Column } from 'types/common';
import useStyles from '../style';
import LightTooltip from 'components/LigthTooltip/ligthTooltip';
import { formatMoney } from 'utils/helpers';

type BodyType = {
  columns: Column[];
  data: any;
  disabledBorderCell?: boolean;
  disableFullborderCell?: boolean;
  onClickItem?: (row: any, column: Column, position?: number) => void;
  indexRow: number;
};

const getBackgroundColor = (data: any) => {
  if (data.amount_faked > 0) return '#FB8C00';
  if (data?.amount_override > 0 && data?.amount_override !== data?.amount_calculated) return '#FFFF6B';
  return 'transparent';
};

const RowTable = ({
  columns,
  data,
  indexRow,
  onClickItem,
  disabledBorderCell = false,
  disableFullborderCell = false,
}: BodyType) => {
  const { paddingCell, borderBottomCell, borderTopCell, borderCellStyle } = useStyles();
  const [open, setOpen] = useState(false);
  const referenceCalculatedValue = useRef(0);

  useEffect(() => {
    if (referenceCalculatedValue.current === 0 && data?.amount_calculated) {
      referenceCalculatedValue.current = data?.amount_calculated;
    }
  }, [data]);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const getBackgroundColorPosted = (index) => {
    if (index === 6 || index === 9) {
      if (!data.posted || data.amount_faked > 0) return '#FB8C00';
    }
    return 'transparent';
  };

  return (
    <>
      {columns?.map(
        (column: Column, index: number) =>
          column?.renderer &&
          (index === 4 ? (
            <ClickAwayListener key={`cell-item-${index}`} onClickAway={handleTooltipClose}>
              <LightTooltip
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                arrow
                placement="top"
                title={
                  <Typography component="span" style={{ color: 'white' }} variant="caption">
                    {`The amount calculated is: ${formatMoney(
                      data.amount_calculated || 0
                    )}`}
                  </Typography>
                }
              >
                <TableCell
                  key={`cell-item-${index}`}
                  align="left"
                  style={{
                    height: 0,
                    minWidth: column.header?.minWidth,
                    width: column.header?.width,
                    backgroundColor: getBackgroundColor(data),
                  }}
                  onMouseEnter={handleTooltipOpen}
                  onMouseLeave={handleTooltipClose}
                  className={`
            ${paddingCell}
            ${!disabledBorderCell && borderBottomCell}
            ${!disabledBorderCell && borderTopCell}
            ${!disableFullborderCell && borderCellStyle}
	        `}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onClickItem) {
                      onClickItem(data, column, indexRow);
                    }
                  }}
                >
                  {column?.renderer({ row: data, column, index, indexRow })}
                </TableCell>
              </LightTooltip>
            </ClickAwayListener>
          ) : (
            <TableCell
              key={`cell-item-${index}`}
              align="left"
              style={{
                height: 0,
                minWidth: column.header?.minWidth,
                width: column.header?.width,
                backgroundColor: getBackgroundColorPosted(index),
              }}
              onMouseEnter={index === 4 ? handleTooltipOpen : undefined}
              onMouseLeave={index === 4 ? handleTooltipClose : undefined}
              className={`
    ${paddingCell}
    ${!disabledBorderCell && borderBottomCell}
    ${!disabledBorderCell && borderTopCell}
    ${!disableFullborderCell && borderCellStyle}
  `}
              onClick={(e) => {
                e.stopPropagation();
                if (onClickItem) {
                  onClickItem(data, column, indexRow);
                }
              }}
            >
              {column?.renderer({ row: data, column, index, indexRow })}
            </TableCell>
          ))
      )}
    </>
  );
};

export default RowTable;
